import React from 'react'
import './ConfirmationInfo.css'

function ConfirmationInfoGO(props) {
  return (
    <>

          <tr>
            <td className='td-title-text'>
              <span className='title-text'>GO #: </span>
              <span className='info-text'>
                {props.confirmationData?.systemOrderNumber}
              </span>
            </td>
          </tr>

          <tr>
            <td className='td-title-text'>
              <span className='title-text'>HBL: </span>
              <span className='info-text'>
                {props.confirmationData?.houseBillNumber}{' '}
              </span>
            </td>
          </tr>
          <tr>
            <td className='td-title-text'>
              <span className='title-text'>MBL: </span>
              <span className='info-text'>
                {props.confirmationData?.masterBillNumber}
              </span>
            </td>
          </tr>
          <tr>
            <td className='td-title-text'>
              <span className='title-text'>AMSBL: </span>
              <span className='info-text'>
                {props.confirmationData?.amsBillNumber}
              </span>
            </td>
          </tr>

    </>
  )
}

export default ConfirmationInfoGO
